module.exports = __webpack_public_path__ + "static/media/Jungle Explorer2.8a40016a.jpg";